(function () {
    const industryFormWrapperEl = /** @type {HTMLElement} */ (document.querySelector('.industry-form-lg-form__container'));
    const industryFormEl = /** @type {HTMLFormElement} */ (document.getElementById('industry-form'));
    const industryFormSubmitBtn = /** @type {HTMLElement} */ (document.getElementById('industry-form-submit-btn'));
    const industryFormResetBtn = /** @type {HTMLElement} */ (document.getElementById('industry-form-reset-btn'));
    const thankYouEl = /** @type {HTMLElement} */ (document.getElementById('industry-form-sent-thank-you'));

    /** @type {FormHandler} */
    let industryFormHandler;
    window.addEventListener('DOMContentLoaded', () => {
        //Submit through the shared B2C lead-gen client call instead of the old divzero fetch.
        industryFormHandler = new FormHandler(null, industryFormEl, null, null, countryCode);
        industryFormHandler.submitHandler = submitLeadGenForm;
        industryFormHandler.onSuccess = industryFormPostSuccess;
    });

    industryFormResetBtn.addEventListener('click', () => {
        industryFormHandler.resetForm();
        industryFormSubmitBtn.classList.remove('d-none');
        industryFormResetBtn.classList.add('d-none');

        industryFormHandler.enableAllInput();

        industryFormWrapperEl.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });

        industryFormWrapperEl.classList.remove('form-sent');
    });

    function industryFormPostSuccess() {
        industryFormSubmitBtn.classList.add('d-none');
        industryFormResetBtn.classList.remove('d-none');

        industryFormHandler.disableAllInputs();

        industryFormEl.classList.add('form-sent');

        thankYouEl.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }
})();
